module.exports = __webpack_public_path__ + "img/yiyao_xuezhi_1.2fb0be91.png";